import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, esES, GridColDef, GridToolbar } from '@mui/x-data-grid';
import { Button, Chip, LinearProgress, useMediaQuery, useTheme } from '@mui/material';
import { UserType } from '../../types/types';
import { useContext, useEffect, useState } from 'react';
import { useDeleteUser, useGetUsers } from '../../hooks/users';
import HeaderFab from '../HeaderFab';
import UsuarioDetail from './UsuariosDetail';
import { UserContext } from '../../contexts/userContext';


export function Usuarios() {
  const { user } = useContext(UserContext);

  const usuarios = useGetUsers(user);

  const [usuarioAEditar, setUsuarioAEditar] = useState<UserType | undefined>();
  const [verDetalleUsuario, setVerDetalleUsuario] = useState(false);

  const [userToDelete, setUserToDelete] = useState<string | null>(null);
  const deleteUSer = useDeleteUser(userToDelete, user);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));


  useEffect(() => {
    if (!deleteUSer.isLoading) {
      setUserToDelete(null);
      setTimeout(() => usuarios.refetch(), 500);

    }
  }, [deleteUSer.isLoading]);

  if (!user?._id) return null;

  const columns: GridColDef[] = [
    {
      field: 'nombre-apellido',
      headerName: 'Nombre y Apellido',
      headerClassName: 'table-headers',
      width: 200,
      renderHeader: () => <strong>Nombre y Apellido</strong>,
      valueGetter: (params) =>`${params.row.firstName} ${params.row.lastName}`,
      renderCell: (params) => {
        const usuario = params.row as UserType;
        return (
          <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left', height: '100%' }}>
            <Button
              onClick={() => {
                setUsuarioAEditar(usuario);
                setVerDetalleUsuario(true);
              }}
              variant="text"
              color="primary"
              fullWidth
              style={{
                whiteSpace: 'pre-wrap',
                textAlign: 'left',
                paddingLeft: 0,
                justifyContent: 'flex-start',
              }}
            >
              {`${params.row.firstName} ${params.row.lastName}`}
            </Button>
            {params.row.username}
            <br />
            {params.row.email}
            {isMobile && (
              <>
                <Button
                  onClick={() => setUserToDelete(params.row._id)}
                  variant='outlined'
                  size='small'
                  color="error"
                  style={{
                    whiteSpace: 'pre-wrap',
                    textAlign: 'left',
                    paddingLeft: 0,
                    marginTop: 'auto',
                    marginBottom: 6,
                  }}
                >
            Eliminar
                </Button>
              </>
            )}
          </div>
        );
      },
    },
    {
      field: 'roles',
      flex: 1,
      headerName: 'Rol',
      headerClassName: 'table-headers',
      renderHeader: () => (<strong>Permisos</strong>),
      renderCell: (params) => (
        <div style={{ textAlign: 'left' }}>
          {params.row.roles.map((p:string) => (
            <Chip
              key={p}
              label={p}
              size="small"
              style={{ margin: 4 }}
            />
          ))}
        </div>
      ),
    },
    {
      field: 'eliminar',
      headerName: 'Eliminar',
      headerClassName: 'table-headers',
      width: 100,
      hide: isMobile,
      renderHeader: () => '',
      renderCell: (params) => (
        <Button
          onClick={() => setUserToDelete(params.row._id)}
          variant='outlined'
          size='small'
          color="error"
          style={{
            whiteSpace: 'pre-wrap',
            textAlign: 'left',
            margin: isMobile ? 3 : undefined,
          }}
        >
            Eliminar
        </Button>
      ),
    },
  ];

  if (usuarios.isLoading || !usuarios.data) return <LinearProgress />;


  return (
    <Box sx={{ height: isMobile ? 'calc(100vh - 60px)' : 'calc(100vh - 115px)', width: 1 }}>
      {usuarios.isFetching && <LinearProgress />}
      <UsuarioDetail
        usuario={usuarioAEditar}
        open={verDetalleUsuario}
        onClose={() => {
          setVerDetalleUsuario(false);
        }}
        setOpen={setVerDetalleUsuario}
        refetchLista={()=>{usuarios.refetch();}}
        lista={usuarios.data}
      />
      <DataGrid
        getRowHeight={() => 'auto'}
        rows={usuarios.data}
        columns={columns}
        getRowId={(row) =>  row._id}
        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
        components={{ Toolbar: GridToolbar }}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        disableSelectionOnClick
        componentsProps={{
          toolbar: {
            csvOptions: { disableToolbarButton: true },
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
      />
      <HeaderFab
        title='Agregar Usuario'
        onclick={()=>{
          setUsuarioAEditar(undefined);
          setVerDetalleUsuario(true);
        }}
      />
    </Box>
  );
}
